import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '顾客姓名',
      dataIndex: 'customerName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.customerName ? t.customerName : '-'
      },
    },
    {
      title: '联系电话',
      dataIndex: 'contactPhone',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.contactPhone ? t.contactPhone  : '-'
      },
    },
    {
      title: '地址',
      dataIndex: 'address',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.address ? t.address : '-'
      },
    },
    {
      title: '咨询、服务与投诉内容',
      dataIndex: 'content',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.content ? t.content : '-'
      },
    },
    {
      title: '处理意见',
      dataIndex: 'handleSuggestion',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handleSuggestion
          ? t.handleSuggestion 
          : '-'
      },
    },
    {
      title: '处理结果',
      dataIndex: 'handleResult',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handleResult ? t.handleResult : '-'
      },
    },
    {
      title: '处理人',
      dataIndex: 'handlerName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handlerName ? t.handlerName : '-'
      },
    },
    {
      title: '处理日期',
      dataIndex: 'handleDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handleDate
          ? moment(t.handleDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
